import React, {Component} from 'react';
import {
    Platform,
    View,
    TouchableOpacity,
    I18nManager,

    Image, ScrollView,
    CheckBox
} from 'react-native';
import HMTextView from "./HMTextView";
import Colors, {colorDark, colorPrimary} from "../tools/Colors"
import {moderateScale} from "../tools/Scaling";

import {connect} from "react-redux";

import PathFile from "../assets/PathFile";
import HMRecycleView from "./HMRecycleView";

import {DataProvider, LayoutProvider} from "recyclerlistview";
import HMFlatList from "./HMFlatList";
import BigList from "react-native-big-list";

class HMListCheckBox extends Component {
    constructor(props) {
        super(props);
        let {data} = props;
        let arraySelect = data.arraySelect;

        // let idx = arraySelect ? arraySelect.findIndex(obj => obj.id === item.id) : -1;

        //   let check1 = arraySelect ? (idx !== -1) : (data.indexSelect == (item.id || (item.id == 0) ? item.id : item.value));
        this.state = {
            numColumns: Platform.OS === "web" ? 3 : 2,
            isSelected: false,
            canChangeSize: false,

            dataProvider: new DataProvider((r1, r2) => {
                return r1 !== r2;
            }),
            layoutProvider: new LayoutProvider(
                () => {
                    return 'VSEL'; //Since we have just one view type
                },
                (type, dim, index) => {
                    switch (type) {
                        case 'VSEL':
                            dim.width = moderateScale(100);
                            dim.height = moderateScale(38);
                            //dim.width = 0;
                            // if (index % 3 === 0) {
                            //     dim.width = 3 * columnWidth;
                            //     dim.height = 300;
                            // } else if (index % 2 === 0) {
                            //     dim.width = 2 * columnWidth;
                            //     dim.height = 250;
                            // } else {
                            //     dim.width = columnWidth;
                            //     dim.height = 250;
                            // }
                            break;
                        default:
                            dim.width = 0;
                            dim.height = 0;
                    }
                }
            ),
        }
    }

    render() {
        const {data, onPress, styleRoot, styleRootChild, viewCustom, type, styleBox = null, styleBoxTick = null} = this.props;
        let arraySelect = data.arraySelect;
        const ITEM_HEIGHT = moderateScale(65); // fixed height of item component
        const NUM_COLUMNS = 3;
        const getItemLayout = (data, index) => {
            return {
                length: ITEM_HEIGHT,
                // offset: ITEM_HEIGHT * data.length,
                offset: ITEM_HEIGHT * index,
                // offset: ITEM_HEIGHT * Math.floor(index / NUM_COLUMNS),
                index,
            };
        };
        const renderOrginal = (item, index) => {
            let idx = arraySelect ? arraySelect.findIndex(obj => obj.id === item.id) : -1;
            let check = arraySelect ? (idx !== -1) : (data.indexSelect == (item.id || (item.id == 0) ? item.id : item.value));

            // let check = arraySelect ? item.tick : (data.indexSelect == (item.id || (item.id == 0) ? item.id : item.value));

            // let idx = arraySelect ? arraySelect.indexOf((item.id || (item.id == 0) ? item.id : item.value)) : -1;
            // let check = arraySelect ? (idx !== -1) : (idx > -1);
            return <View
                key={`${item.id ? item.id : item.value}` + index}
                style={[{
                    flexDirection: 'row',
                    marginHorizontal: moderateScale(6),
                    alignItems: 'center',
                    //  justifyContent: 'center',
                    height: moderateScale(34),
                    // width: moderateScale(100),
                }, styleRootChild ? styleRootChild : {}]}


            >
                <TouchableOpacity
                    style={{
                        width: moderateScale(24),
                        height: moderateScale(24),
                        backgroundColor: '#ffffff',
                        borderRadius: moderateScale(arraySelect ? 4 : 12),
                        alignItems: 'center', justifyContent: 'center',
                        borderWidth: moderateScale(1),
                        borderColor: Colors.gray

                    }}
                    onPress={
                        () => {
                            this.props.data.list[index].tick = !this.props.data.list[index].tick;

                            this.setState({isSelected: !check})
                            onPress(item, data.name, (data?.list.length == 1) && check)
                        }}
                >
                    <Image
                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                        source={PathFile.image.Check}
                        //resizeMode="stretch"
                        style={[!check ? {
                            width: moderateScale(0),
                            height: moderateScale(0),
                        } : {


                            width: moderateScale(18),
                            height: moderateScale(18),
                        }]}/>
                </TouchableOpacity>
                <HMTextView
                    //  numberOfLines={1}
                    // type={'bold'}
                    text={item.name ? item.name : item.label}
                    style={{

                        color: Colors.colorDarkText,
                        // marginEnd: moderateScale(10),
                        fontSize: moderateScale(12),
                        // textAlign: 'center',
                        marginHorizontal: moderateScale(4)

                    }}
                    styleRoot={{flexWrap: 'wrap',}}

                />

                {
                    viewCustom ?
                        viewCustom(item, index)
                        : null
                }
            </View>
        }


        const renderItem = (typeRender, item, index) => {
            switch (type) {
                case "flatlist":
                    let item1 = typeRender.item;
                    let index1 = typeRender.index;
                    return renderOrginal(item1, index1);

                case "largList":
                    let item2 = typeRender.item;
                    let index2 = typeRender.index;
                    return renderOrginal(item2, index2);
                case "recycle":
                    if (Platform.OS !== "web") {
                        // item = typeRender.item;
                        // index = typeRender.index;

                        // item = typeRender.item;
                        // index = typeRender.index;
                    }

                    return renderOrginal(item, index);


                default :
                    let item3 = typeRender;
                    let index3 = item;
                    return renderOrginal(item3, index3);

            }


        };


        const keyExtractor = (item, index) => item.tick + "_" + index;
        const {isSelected} = this.state;
        // let check = isSelected;
        return (
            type == "flatlist" ?
                <HMFlatList
                    renderItem={renderItem}
                    //   renderFooter={this.renderFooter.bind(this)}
                    // columnCount={this.state.columnCount}
                    //initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                    //  refreshing={this.props.showRefresh}
                    keyExtractor={keyExtractor}
                    data={data.list}
                    extraData={{
                        list: data.list,
                    }}
                    numColumns={this.state.numColumns}
                    getItemLayout={getItemLayout}
                    // Performance settings
                    removeClippedSubviews={true} // Unmount components when outside of window
                    initialNumToRender={5} // Reduce initial render amount
                    maxToRenderPerBatch={5} // Reduce number in each render batch
                    updateCellsBatchingPeriod={100} // Increase time between renders
                    windowSize={7} // Reduce the window size
                />
                :
                (type === "largList") ?
                    <BigList
                        renderItem={renderItem}
                        //   renderFooter={this.renderFooter.bind(this)}
                        // columnCount={this.state.columnCount}
                        //initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                        //  refreshing={this.props.showRefresh}
                        keyExtractor={keyExtractor}
                        data={data.list}
                        numColumns={this.state.numColumns}

                    />
                    :
                    (type ?

                        (data.list && data.list.length > 0 ?
                                <HMRecycleView
                                    style={{flex: 1}}
                                    contentContainerStyle={{margin: 3}}
                                    // onEndReached={this.handleLoadMore.bind(this)}
                                    dataProvider={this.state.dataProvider.cloneWithRows(data.list)}
                                    layoutProvider={this.state.layoutProvider}
                                    renderAheadOffset={0}
                                    // canChangeSize={this.state.canChangeSize}
                                    forceNonDeterministicRendering={true}
                                    extendedState={{
                                        // heightSlider: heightSlider,
                                        // widthSlider: widthSlider,
                                        // list: data.list,
                                    }}
                                    //  onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                    //   forceNonDeterministicRendering={true}


                                    //application
                                    rowRenderer={renderItem}
                                    //   renderFooter={this.renderFooter.bind(this)}
                                    // columnCount={this.state.columnCount}
                                    //initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                                    //  refreshing={this.props.showRefresh}
                                    keyExtractor={keyExtractor}
                                    data={data.list}
                                />
                                :
                                null
                        )
                        :
                        <ScrollView
                            removeClippedSubviews={true}
                        >

                            <View
                                style={[{
                                    flexDirection: "row",
                                    flexWrap: 'wrap',
                                    flex: 1,
                                    flexGrow: 1,
                                    //   backgroundColor: "#ee3548"
                                }, styleRoot]}>
                                {
                                    data.list.map(renderItem)
                                }

                            </View>

                        </ScrollView>)

        );
    }

//      <ScrollView
//
//                     style={[{
//                         //alignSelf: 'center',
//                         //    backgroundColor:'#ee015f'
//                     }]}
//                     contentContainerStyle={{}}
//
//                 >
//                     <View
//                         style={[{
//                             flexDirection: 'row',
//                             //   marginHorizontal: moderateScale(30),
//                             // alignItems: 'center',
//                             // justifyContent:'center',
//                             flexWrap: 'wrap',
//                             //flex: 1,
//
//                             flexGrow: 1,
//
//                             //   backgroundColor: "#b0ee56"
//                             //
//                         }, styleRoot]}>
//                         {
//                             data.list.map((item, index) => {
//                                 let idx = arraySelect ? arraySelect.findIndex(obj => obj.id === item.id) : -1;
//
//                                 let check = arraySelect ? (idx !== -1) : (data.indexSelect == (item.id || (item.id == 0) ? item.id : item.value));
//
//                                 return <TouchableOpacity
//                                     style={{
//                                         flexDirection: 'row',
//                                         marginHorizontal: moderateScale(6),
//                                         alignItems: 'center',
//                                         //justifyContent: 'center',
//                                         height: moderateScale(34)
//                                     }}
//                                     onPress={
//                                         () => {
//                                             onPress(item, data.name, (data?.list.length == 1) && check)
//                                         }}>
//                                     <View style={{
//                                         width: moderateScale(24),
//                                         height: moderateScale(24),
//                                         backgroundColor: '#ffffff',
//                                         borderRadius: moderateScale(12),
//                                         alignItems: 'center', justifyContent: 'center',
//                                         borderWidth: moderateScale(1),
//                                         borderColor: Colors.gray
//
//                                     }}>
//                                         <Image
//                                             // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
//                                             source={PathFile.image.Check}
//                                             //resizeMode="stretch"
//                                             style={[!check ? {
//                                                 width: moderateScale(0),
//                                                 height: moderateScale(0),
//                                             } : {
//
//
//                                                 width: moderateScale(18),
//                                                 height: moderateScale(18),
//                                             }]}/>
//                                     </View>
//                                     <HMTextView
//                                         //  numberOfLines={1}
//                                         // type={'bold'}
//                                         text={item.name ? item.name : item.label}
//                                         style={{
//
//                                             color: Colors.colorDarkText,
//                                             // marginEnd: moderateScale(10),
//                                             fontSize: moderateScale(12),
//                                             // textAlign: 'center',
//                                             marginHorizontal: moderateScale(4)
//
//                                         }}/>
//
//                                     {
//                                         viewCustom ?
//                                             viewCustom(item, index)
//                                             : null
//                                     }
//                                 </TouchableOpacity>
//
//                             })
//                         }
//
//                     </View>
//                 </ScrollView>
}


const mapStateToProps = (state) => {

    return {}
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(HMListCheckBox);
